import { Add } from '@material-ui/icons';
import { Button, Popover } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { getAiTypeActionLabel } from '../../../../board/utils';
import { ReadOnlyComp } from '../../../../read-license/index';
import { Chips } from './index';
import { ConversationBanner } from './ConversationBanner';

const Wrapper = styled.div`
  margin-top: 0;
  margin-bottom: 0;

  h1 {
    margin: 0;
    font-size: 1.5rem;
    line-height: 2.5rem;
    font-weight: bold;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const Header = (readOnly) => {
  const [open, setOpen] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [rolEvent, setRolEvent] = useState(null);
  const anchor = useRef();
  const readFlag = readOnly.readOnlyePermission;
  const isUserReadOnly = readOnly.readOnlyFeatureFlag;
  const page = new URL(window.location.href).pathname;
  const label = getAiTypeActionLabel();
  const { t } = useTranslation();

  const handleAddActionItem = () => {
    if (readFlag && isUserReadOnly) {
      setIsRead(true);
      setRolEvent({
        rolEventTarget: "Add Action Item",
        rolEventType: "Click",
        rolEventSource: page
      })
      console.log("Setting the event as: " + rolEvent);
    } else {
      setOpen(!open);
      setRolEvent(null);
      openFullPopUp(aiFullViewPopUp, '/wb/activity/aI/?id=-1&dummyAi=yes', '');
    }
  };

  const handleButtonClose = async () => {
    setIsRead(false);
  }
  return (
    <Wrapper>
      <Row>
        <h1>{t('My Work')}</h1>
        {
          readFlag && isUserReadOnly ?
            <div>
              <Button
                variant="primary"
                size="large"
                ref={anchor}
                startIcon={<Add />}
                onClick={handleAddActionItem}
                style={{ backgroundColor: '#b7d6e5', color: '#ffffff' }}
              >
                {t('Add Action')}
              </Button>
              {
                isRead && (
                  <Popover
                    targetRef={anchor}
                    removeActions
                    removeClose
                    arrow={false}
                    placement="bottom-start"
                    open={isRead}
                    onDismiss={() => setIsRead(false)}
                    className="readOnlyOver"
                    content={
                      <ReadOnlyComp
                        handleClose={handleButtonClose}
                        rolEvent={rolEvent}
                      />
                    }
                  />
                )
              }
            </div>
            :
            <div>
              <Button
                variant="primary"
                size="large"
                ref={anchor}
                startIcon={<Add />}
                onClick={handleAddActionItem}
              >
                {t('Add Action')}
              </Button>
            </div>
        }
      </Row>
      {Boolean(window.wbConfig?.conversationCycleEnabled) && <ConversationBanner />}
      <Row>
        <Chips />
      </Row>
    </Wrapper>
  );
};
